import React from 'react';

import { Campings } from '@components';
import { scrollTop } from '@share/utils';

import './style.scss';

interface IProps {}

class CampingsPageComponent extends React.Component<IProps> {
  componentDidMount() {
    // Scroll to top immediately when component mounts
    scrollTop();
    // Also ensure scroll position is maintained after content loads
    setTimeout(() => {
      scrollTop();
    }, 300);
  }

  render(): React.ReactNode {
    return (
      <div className="campings-page">
        <Campings />
      </div>
    );
  }
}

export const CampingsPage = CampingsPageComponent;
